const onboardingES = {
	/* ---------- COMMON ---------- */
	showSteps: "Mostrar pasos",
	hideSteps: "Ocultar pasos",
	stepsCompleted: "pasos completados",

	/* ---------- BUBBLE / HINT ---------- */
	hintTitle: "Completa tu configuración",
	hintText: "Finaliza estos pasos para activar tu tienda y comenzar a recibir reservas.",

	/* ---------- OWNER / ADMIN ---------- */
	launchShop: "Lanzar tienda",
	launching: "Redirigiendo...",
	errors: {
		billing: "No se pudo iniciar la facturación",
	},
	steps: {
		shopInfo: "Información de la tienda",
		schedule: "Horario del personal",
		services: "Agregar servicios",
		images: "Subir imágenes",
		openingHours: "Horario de apertura",
		contactInfo: "Información de contacto",
		attributes: "Atributos",
	},

	/* ---------- STAFF ---------- */
	staff: {
		launch: "Activar perfil del personal",
		launching: "Activando...",
		steps: {
			schedule: "Agregar disponibilidad",
			services: "Vincular servicios",
		},
		messages: {
			success: "¡Perfil del personal activado!",
			error: "No se pudo activar el perfil del personal.",
		},
	},
};

export default onboardingES;
